import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserMatch } from '../user-match.model';
import { UserMatchTableStatistic } from '../user-match-table-statistic.model';

@JsonObject('UserMatchesResultsResponse')
export class UserMatchesResultsResponse extends ApiResultsResponse<UserMatch> {

  @JsonProperty('results', [UserMatch])
  override results: UserMatch[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;

  @JsonProperty('exited_count', Number)
  exitedCount: number = 0;

  @JsonProperty('matchs_tables_statistics', [UserMatchTableStatistic])
  matchsTablesStatistics: UserMatchTableStatistic[] = [];
}
